import { useNavigate } from 'react-router-dom';
import { useUploadStatus } from '../utils/UploadStatusContext';

export const useNavigationGuard = () => {
  const navigate = useNavigate();
  const { uploadStatus } = useUploadStatus();

  const customNavigate = (path, options = {}) => {
      // Check if upload has started and is currently in the uploading phase
      if (uploadStatus.started && uploadStatus.uploading && !uploadStatus.completed) {
          const confirmLeave = window.confirm('Sicher, dass Sie beenden wollen? Upload läuft.');
          if (!confirmLeave) return; // If user decides not to leave, return without navigating
      }
      navigate(path, options); // Proceed with navigation if user confirms or upload isn't in the critical phase
  };

  return customNavigate;
};
